// extracted by mini-css-extract-plugin
export var gif = "_it-0";